export class User {
    public strUserId?: string; 
    public strUserName?: string; 
    public strRolId?: string; 
    public strRolName?: string; 
    public strRolTipo?: string; 
    public strEntidadId?: string; 
    public strEntidadName?: string; 
    public strActivo?: string;            
}